import { List, Map, Record } from "immutable";

import { ContentType } from "@seneca/course-service-types";

import {
  AssignmentType,
  defaultAssignmentValues,
  ReceivedAssignmentStatus
} from "seneca-common/features/assignments/state";

import AverageStats from "./AverageStats";
import ContentStat from "./ContentStat";
import QuestionStat from "./QuestionStat";
import QuizDetails from "./QuizDetails";
import QuizStats from "./QuizStat";
import SectionStat from "./SectionStat";
import VocabularyWordStat from "./VocabularyWordStat";

export type StudentAssignmentType = AssignmentType & {
  userId?: string;
  status?: ReceivedAssignmentStatus;
  sectionStats?: Map<string, SectionStat>;
  contentStats?: Map<string, Map<ContentType, ContentStat>>;
  averageStats?: AverageStats;
  questionStats?: Map<string, QuestionStat>;
  quizStats?: Map<string, QuizStats>;
  quizDetails?: Map<string, QuizDetails>;
  vocabularyStats?: Map<string, VocabularyWordStat>;
  teacherName?: string;
  contentTypesBySectionId?: Map<string, List<ContentType>>;
};

export const defaultStudentAssignmentValues: StudentAssignmentType = {
  ...defaultAssignmentValues,
  userId: undefined,
  status: undefined,
  teacherName: undefined,
  sectionStats: Map<string, SectionStat>(),
  contentStats: Map<string, Map<ContentType, ContentStat>>(),
  questionStats: Map<string, QuestionStat>(),
  averageStats: new AverageStats(),
  quizStats: Map<string, QuizStats>(),
  quizDetails: Map<string, QuizDetails>(),
  vocabularyStats: Map<string, VocabularyWordStat>(),
  contentTypesBySectionId: Map<string, List<ContentType>>()
};
export default class StudentAssignment extends Record(
  defaultStudentAssignmentValues
) {}
